export default {
  SET_STATUSES: (state, payload) => (state.statuses = payload),
  SET_GROUPS: (state, payload) => (state.groups = payload),
  SET_TYPES: (state, payload) => (state.types = payload)
}
